module.exports = __webpack_public_path__ + "static/Resin Veneers intraoral before-2a1710c9739bb09d413f29aed3de67be.jpg";